module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4Hu0mf/cover.jpeg?1736791168185",
      "alt": "This image is the cover for the book Beyond Sight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beyond Sight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jonny Sears, a young boy seeking refuge from his parents’ troubles, embarks on a summer adventure that takes a terrifying turn when he finds himself trapped in the depths of hell, encountering both benevolent and malevolent characters as he navigates the treacherous landscape, testing his resilience and determination in a gripping tale of a perilous odyssey that will leave readers breathless, wondering if Jonny will ever find his way back to the world he once knew.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrew Nichols\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andrew Nichols was born in Newcastle, Northeast England. Raised by his mother, Lynne, and father, Steven, in a small old mining town called Springwell Village, Gateshead. Surrounded by adventurous fields, railways, quarries and animals, his imagination was able to run wild. In his spare time, he enjoys writing poems, stories and songs. Spending much time raising his much beloved two daughters, Iyla and Lily, he is most happy. He moved with his family to southern England in 2009 and currently lives in Didcot. Andrew is equally happy walking the Oxfordshire hills and riverways between keeping fit with his martial arts.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0